import React, { useEffect, useState } from "react";
import { ListPanelEntityModel } from "../../../product/ListPanel/ListPanelModel";
import { useNavigate } from "react-router-dom";
import { PageModel } from "../../../core/Models/PageModel";
import { ArticleModel } from "../../Article/ArticleModel";
import { Theme } from "../../../core/Models/CustomSiteConfigModel";
import { themeService } from "../../../core/NotificationStripNav/ThemeService";

import "./PressTimelineItem.css";
import Utils from "../../../core/Utils/Utils";

const PressTimelineItem: React.FC<{ blok: ListPanelEntityModel }> = ({
  blok,
}) => {
  const navigate = useNavigate();
  const [theme, setTheme] = useState<Theme | null>(themeService.getTheme());

  useEffect(() => {
    const unsubscribe = themeService.subscribe(setTheme);
    return () => unsubscribe();
  }, []);

  const entity = blok?.content as PageModel;
  if (!entity) {
    return null;
  }
  const publicationPartner = entity?.body
    ? (entity?.body[0] as ArticleModel).publicationPartner
    : " ";

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (blok.full_slug) {
      navigate(`/${blok.full_slug}`);
    }
  };

  return (
    <div
      className={`press-timeline-item`}
      style={{ borderColor: theme?.textColor }}
      id="article"
    >
      <div className="item-image" onClick={handleClick}>
        {entity.image?.filename && (
          <img
            src={Utils.getCacheUrl(entity.image?.filename)}
            alt=""
            onError={(e) => Utils.handleImageError(e, entity.image.filename)}
          />
        )}
      </div>
      <div className="item-content" onClick={handleClick}>
        <div className="item-partner">{publicationPartner}</div>
        <div className="item-description">
          <span>{entity.shortTitle} </span> <span>&nbsp; &#8594;</span>
        </div>
      </div>
    </div>
  );
};

export default PressTimelineItem;
